/** Copy of the vendorInvoices page (Operations), ported from VentaHub. */
export const vendorInvoices = {
  actions: {
    record: 'Record a vendor invoice',
    editHeader: 'Edit header',
    editLines: 'Edit lines',
    download: 'Download invoice',
    delete: 'Delete',
  },
  editor: {
    skuCode: 'SKU code',
    boxCode: 'Box code',
    quantity: 'Units',
    cost: 'Cost per unit',
    vat: 'VAT %',
    expiry: 'Expiry (YYYY-MM-DD)',
  },
  form: {
    hint: '1. Choose the warehouse, vendor and the vendor order it delivers. 2. Fill in the header. 3. List what was received, one line per SKU and box. Check, then record: the units go into the boxes.',
    scope: 'Warehouse · Vendor',
    chooseWarehouseAndVendorFirst: 'Choose a warehouse and a vendor first.',
    chooseVendor: 'Choose a vendor',
    vo: 'Vendor order code',
    chooseVo: 'Choose a vendor order',
    currency: 'Currency',
    amount: 'Amount incl. tax',
    credit: 'Credit days',
    shipping: 'Shipping',
    customs: 'Customs duty',
    other: 'Other costs',
    cbm: 'Volume (m³)',
    comment: 'Comment',
    lines: 'Lines received',
    linesHint:
      'SKU code is ours or the retailer’s. A box code the warehouse does not have opens a new box (4 of 0-9, A-Z). Cost, VAT % and expiry are optional. Units and the total before tax are worked out from the lines.',
    chooseWarehouse: 'Choose a warehouse.',
    needVendor: 'Choose a vendor.',
    needVo: 'Fill in the vendor order code.',
    needNumber: 'Fill in the invoice number.',
    badCurrency: 'Type a 3-letter currency code.',
    dateAfterReceived: 'The invoice date cannot be after the received date.',
    badAmount: 'Type a number of zero or more, to four decimals.',
    badWhole: 'Type a whole number.',
    noLines: 'Add at least one line.',
    badLine: 'Line {{line}}: {{field}} is missing or not valid.',
    line: 'Line {{line}}: ',
    noProblems: 'No problems found. It is ready to save.',
    downloadProblems: 'Download problems',
    recordButton: 'Record invoice',
    recorded: 'Vendor invoice {{code}} recorded.',
    downloadTemplate: 'Download template',
    uploadFile: 'Upload details from file',
    noFileRows: 'No SKU/Box rows found in the file.',
    cannotReadFile: 'Could not read the file.',
    loaded_one: 'Loaded {{count}} line from the file.',
    loaded_other: 'Loaded {{count}} lines from the file.',
    loadedIncomplete_one: '{{count}} missing a SKU or box code',
    loadedIncomplete_other: '{{count}} missing a SKU or box code',
    loadedUnreadableExpiry_one: '{{count}} with an unreadable expiry date (use YYYY-MM-DD)',
    loadedUnreadableExpiry_other: '{{count}} with an unreadable expiry date (use YYYY-MM-DD)',
  },
  edit: {
    title: 'Edit {{code}}',
    hint: 'The warehouse, vendor, vendor order and lines stay as they are.',
    saved: 'Vendor invoice {{code}} saved.',
  },
  delete: {
    title: 'Delete {{code}}?',
    description:
      'Its units go back out of their boxes. Not possible once a payment is recorded, or if the units have gone out or are blocked.',
    done: 'Vendor invoice {{code}} deleted.',
  },
  title: 'Vendor invoices',
  description: 'What vendors have billed us, and what has been paid.',
  empty: 'No vendor invoices to show',
  emptyHint: 'Nothing matches these filters.',
  filters: {
    warehouse: 'Warehouse',
    party: 'Vendor',
    text: 'Invoice number',
    dates: 'Invoice date',
    void: 'Include voided',
  },
  columns: {
    number: 'Invoice number',
    date: 'Invoice date',
    warehouse: 'Warehouse',
    party: 'Vendor',
    receivedDate: 'Received',
    units: 'Units',
    amountWoTax: 'Excl. tax',
    amount: 'Amount',
    paid: 'Paid',
    cndnValue: 'Credit/debit notes',
    shippingCost: 'Shipping',
    customsDuty: 'Customs',
    otherCost: 'Other',
    creditPeriod: 'Credit days',
    voId: 'Vendor order',
    valid: 'Status',
  },
  open: 'Open {{code}}',
  lines: {
    editTitle: 'Edit the lines of {{code}}',
    editHint:
      'The lines become these. Only the difference moves: more units go into their boxes, fewer come back out.',
    title: 'Lines',
    description: 'What is on this document.',
    empty: 'No lines on this document.',
    columns: {
      skuCode: 'SKU',
      skuName: 'Name',
      boxCode: 'Box',
      quantity: 'Quantity',
      cost: 'Cost',
      vatRate: 'VAT %',
      expiryDate: 'Expiry',
    },
  },
} as const
